<ion-header class="ion-no-border">

    <ion-toolbar>
        <ion-buttons slot="start">
            <ion-button (click)="close()">
                <fa-icon [icon]="['far', 'times']" size="lg" [fixedWidth]="true" slot="start"></fa-icon>
            </ion-button>
        </ion-buttons>
        <ion-title>Bank transfer payment</ion-title>
    </ion-toolbar>

    <ion-segment color="primary" [(ngModel)]="segment">
        <ion-segment-button value="has_paid" checked>
            <ion-label>Has paid</ion-label>
        </ion-segment-button>
        <ion-segment-button value="will_pay">
            <ion-label>Will pay</ion-label>
        </ion-segment-button>
    </ion-segment>

</ion-header>

<ion-content>

    <ng-container [ngSwitch]="segment">

        <ng-container *ngSwitchCase="'has_paid'">

            <ion-grid class="large-inputs" style="width: 400px;" *ngIf="cart">
                <ion-row class="ion-align-items-center ion-justify-content-center">
                    <ion-col>
                        <ion-list>
                            <ion-item lines="none" detail="false" class="ion-text-center">
                                <div class="warning-box">
                                    <p>You need to ensure the customer has completed a bank transfer before adding a payment.</p>
                                </div>
                            </ion-item>
                            <ion-item lines="full" style="margin-top: 40px">
                                <ion-label>Amount due</ion-label>
                                {{cart.currency.sign}}{{cart.amount_due | number:'1.2'}}
                            </ion-item>
                            <ion-item lines="full">
                                <ion-input type="tel" class="ion-text-right" inputmode="decimal" maxlength="10" label="Payment amount" [(ngModel)]="payment_amount" (ngModelChange)="sanitisePaymentAmount()"></ion-input>
                            </ion-item>
                            <ion-item *ngIf="payment.price > 0" button="true" lines="none" detail="false" color="success" class="ion-text-center" (click)="addPayment()">
                                <ion-label>ADD PAYMENT</ion-label>
                            </ion-item>
                        </ion-list>
                    </ion-col>
                </ion-row>
            </ion-grid>

        </ng-container>

        <ng-container *ngSwitchCase="'will_pay'">

            <ion-grid class="large-inputs" style="width: 400px;">
                <ion-row class="ion-align-items-center ion-justify-content-center">
                    <ion-col>
                        <ion-list *ngIf="this.cart.person">
                            <ion-item lines="none" detail="false" class="ion-text-center">
                                <div class="warning-box">
                                    <p>Order will be put through as awaiting payment by bank transfer.</p>
                                    <p>You need to email the customer a receipt which will include bank transfer details.</p>
                                </div>
                            </ion-item>
                            <ion-item lines="none" detail="false" style="margin-top: 50px">
                                <ion-toggle label-placement="start" *ngIf="!cart['shipping_address']" [(ngModel)]="params['fulfilled']">Mark order as fulfilled</ion-toggle>
                                <ion-toggle label-placement="start" *ngIf="cart['shipping_address']" disabled="true" [(ngModel)]="params['fulfilled']">Mark order as fulfilled</ion-toggle>
                            </ion-item>
                            <ion-item button="true" lines="none" detail="false" color="success" class="ion-text-center" (click)="placeOrder()">
                                <ion-label>PLACE ORDER</ion-label>
                            </ion-item>
                        </ion-list>
                        <div *ngIf="!this.cart.person" class="warning-box">
                            <p>Your cart does not have a customer assigned.</p>
                        </div>
                    </ion-col>
                </ion-row>
            </ion-grid>

        </ng-container>

    </ng-container>

</ion-content>